/**
 * TouchRipple.js
 * Ripple effect for touch events
 *
 * @class   TouchRipple
 * @author  Randy Lebeau
 *
 */

import React from 'react';
import ClassNames from 'classnames';
import Dom from '../../../utils/dom';
import RippleCircle from '../ripple-circle/RippleCircle';

export default React.createClass({

	displayName: "TouchRipple",

	propTypes: {
		centerRipple: React.PropTypes.bool,
		className: React.PropTypes.string
	},

	getInitialState() {
		return {
			ripples: [{
				key: 0,
				started: false,
				ending: false
			}]
		};
	},

	render() {
		let classes = ClassNames('lui-touch-ripple');

		return (
			React.createElement("div", {
					onMouseUp: this._handleMouseUp,
					onMouseDown: this._handleMouseDown,
					onMouseOut: this._handleMouseOut,
					onTouchStart: this._handleTouchStart,
					onTouchEnd: this._handleTouchEnd
				},
				React.createElement("div", {
						className: classes
					},
					this._getRippleElements()
				),
				this.props.children
			)
		);
	},

	start(e) {

		let ripples = this.state.ripples,
			nextKey = ripples[ripples.length - 1].key + 1,
			style = !this.props.centerRipple ? this._getRippleStyle(e) : {},
			ripple;

		//Start the next unstarted ripple
		for (let i = 0; i < ripples.length; i++) {
			ripple = ripples[i];
			if (!ripple.started) {
				ripple.started = true;
				ripple.style = style;
				break;
			}
		};

		//Add an unstarted ripple at the end
		ripples.push({
			key: nextKey,
			started: false,
			ending: false
		});

		//Re-render
		this.setState({
			ripples: ripples
		});
	},

	end() {

		let ripples = this.state.ripples,
			ripple,
			endingRipple;

		//End the the next un-ended ripple
		for (let i = 0; i < ripples.length; i++) {
			ripple = ripples[i];
			if (ripple.started && !ripple.ending) {
				ripple.ending = true;
				endingRipple = ripple;
				break;
			}
		};

		//Only update if a ripple was found
		if (endingRipple) {
			//Re-render
			this.setState({
				ripples: ripples
			});

			//Wait 2 seconds and remove the ripple from DOM
			setTimeout(function() {
				ripples.shift();
				if (this.isMounted()) {
					this.setState({
						ripples: ripples
					});
				}
			}.bind(this), 2000);
		}
	},

	_handleMouseDown(e) {
		//only listen to left clicks
		if (e.button === 0) this.start(e);
	},

	_handleMouseUp(e) {
		this.end();
	},

	_handleMouseOut(e) {
		this.end();
	},

	_handleTouchStart(e) {
		this.start(e);
	},

	_handleTouchEnd(e) {
		this.end();
	},

	_getRippleStyle(e) {
		let style = {},
			el = React.findDOMNode(this),
			elHeight = el.offsetHeight,
			elWidth = el.offsetWidth,
			offset = Dom.offset(el),
			pageX = e.pageX == undefined ? e.nativeEvent.pageX : e.pageX,
			pageY = e.pageY == undefined ? e.nativeEvent.pageY : e.pageY,
			pointerX = pageX - offset.left,
			pointerY = pageY - offset.top,
			topLeftDiag = this._calcDiag(pointerX, pointerY),
			topRightDiag = this._calcDiag(elWidth - pointerX, pointerY),
			botRightDiag = this._calcDiag(elWidth - pointerX, elHeight - pointerY),
			botLeftDiag = this._calcDiag(pointerX, elHeight - pointerY),
			rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag),
			rippleSize = rippleRadius * 2,
			left = pointerX - rippleRadius,
			top = pointerY - rippleRadius;

		style.height = rippleSize + 'px';
		style.width = rippleSize + 'px';
		style.top = top + 'px';
		style.left = left + 'px';

		return style;
	},

	_calcDiag(a, b) {
		return Math.sqrt((a * a) + (b * b));
	},

	_getRippleElements() {
		return this.state.ripples.map(function(ripple) {
			return (
				React.createElement(RippleCircle, {
					key: ripple.key,
					started: ripple.started,
					ending: ripple.ending,
					style: ripple.style
				})
			);
		}.bind(this));
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/animations/touch-ripple/TouchRipple.js
 **/